function getQueryVariable (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}

function getRootUrl () {
  return window.location.origin
    ? window.location.origin
    : window.location.protocol + '//' + window.location.host
}

function windowLocation (url, blob) {
  var X = setTimeout(function () {
    window.location.replace(url)
    return true
  }, 300)

  if ((window.location = url)) {
    clearTimeout(X)
    return true
  } else {
    if ((window.location.href = url)) {
      clearTimeout(X)
      return true
    } else {
      clearTimeout(X)
      window.location.replace(url)
      return true
    }
  }
}

function getQueryParamaterValue (url, variable) {
  var query = url.substring(url.indexOf('?') + 1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return ''
}

export {
  getQueryVariable,
  getRootUrl,
  windowLocation,
  getQueryParamaterValue
}

export default {
  getQueryVariable,
  getRootUrl,
  windowLocation,
  getQueryParamaterValue
}
